module.exports = __webpack_public_path__ + "static/media/izumi_og.fbcaf074.png";